import type React from 'react';

import { useGetResources } from '@hooks/useGetResources';
import { MalgruppeType } from '@src/types/minhelseentities';

import { TagComponent } from './tag-component';

interface Props {
  malgruppeType: MalgruppeType;
}

const MalgruppeTag = ({ malgruppeType }: Props): React.JSX.Element | null => {
  const resources = useGetResources();
  switch (malgruppeType) {
    case MalgruppeType.Barn:
      return <TagComponent tagValue={resources?.verktoyDetails_MalgruppeType_Barn} />;
    case MalgruppeType.Ungdom:
      return <TagComponent tagValue={resources?.verktoyDetails_MalgruppeType_Ungdom} />;
    case MalgruppeType.Voksne:
      return <TagComponent tagValue={resources?.verktoyDetails_MalgruppeType_Voksne} />;
    case MalgruppeType.Eldre:
      return <TagComponent tagValue={resources?.verktoyDetails_MalgruppeType_Eldre} />;
    default:
      return null;
  }
};

export default MalgruppeTag;
